export const PRODUCTS = {
    DEPOSIT: 'deposit',
    VERIFY: 'verify',
    PAYLINK: 'paylink',
    EMPLOYER_LINK_VERIFY: 'employerLinkVerify',
    SWITCH: 'switch',
    PRESENT: 'present'
};
//# sourceMappingURL=products.js.map